module.exports = __webpack_public_path__ + "img/WEP-min.1124b8cb.png";